import React from 'react'

const ReportsSystemReportDocument = () => {
  return (
    <>
      <h4 className="doc-title mb-2">System Report</h4>
      <p>
        This report allows users to view System data filtered by Site, 
        with the option to export the data. It includes details such as
        Branch Office, Customer Name, Customer Number, Site Number, Site Name,
        Panel Type Name, System Name, System Status, System Address, Software Version,
        and Contract Number(s). Report includes only data from Inspection Tasks that have at least one equipment.
      </p>

      <p>
        System report will be accessible to all users based on their mapped Sales Offices.
        Super Admin and Support users will have access to all systems, regardless of the Branch Offices.
      </p>
    </>
  );
}
export default ReportsSystemReportDocument;